import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/about")({
  component: AboutPage,
  head: () => ({
    meta: [
      {
        property: "og:title",
        content: "About - Macrowave",
      },
      {
        property: "og:description",
        content: "Learn about Macrowave, the peer-to-peer audio sharing application that transforms how people experience audio together.",
      },
      {
        name: "description",
        content: "Learn about Macrowave, the peer-to-peer audio sharing application that transforms how people experience audio together.",
      },
    ],
  }),
});

function AboutPage() {
  return (
    <div className="mx-auto max-w-4xl py-12 px-6">
      <div className="text-center mb-12">
        <h1 className="font-serif-600 text-4xl text-black mb-4">
          About Macrowave
        </h1>
      </div>

      <div className="font-serif text-lg leading-relaxed space-y-8 text-gray-800">
        <p>
          Macrowave started with a simple idea from <a href="https://necmttn.com" className="text-black hover:text-gray-600 transition-colors duration-200 underline" target="_blank">Neco</a>:
        </p>

        <blockquote className="border-l-8 border-black pl-4 py-4 my-8 italic">
          I want one of you guys to build a p2p radio protocol so I can broadcast whatever I'm listening to.
        </blockquote>

        <p>
          What began as a weekend hack between friends turned into something special. <a href="https://lucas.love" className="text-black hover:text-gray-600 transition-colors duration-200 underline" target="_blank">Lucas</a> and Neco built Macrowave to solve a problem we all have: sharing what we're experiencing in real-time, without the friction.
        </p>

        <div>
          <h2 className="font-serif-600 text-2xl text-black mb-4">
            Broadcasting Made Simple
          </h2>
          <p>
            Share your screen and audio with anyone, instantly. No complex setup, no streaming keys, no hassle. Whether you're DJing for friends, teaching a workshop, or sharing your creative process, Macrowave gets out of your way and lets you focus on what matters.
          </p>
          <p className="mt-4">
            Your audience just needs a link. They can tune in from any browser on any device—desktop, mobile, anywhere. Clean, simple, accessible.
          </p>
        </div>

        <div>
          <h2 className="font-serif-600 text-2xl text-black mb-4">
            What Makes It Different
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Start broadcasting in seconds, not minutes</li>
            <li>Crystal-clear audio with minimal delay</li>
            <li>Works everywhere—macOS app for broadcasting, web for listening</li>
            <li>No accounts, no configuration, just go live</li>
            <li>Perfect for music sessions, co-working, teaching, or just hanging out</li>
          </ul>
        </div>

        <div>
          <h2 className="font-serif-600 text-2xl text-black mb-4">
            Ready to Start?
          </h2>
          <p className="mb-4">
            Download the macOS app to start broadcasting, or visit any station link to listen from your browser. It's that simple.
          </p>
          <a href="https://apps.apple.com/app/apple-store/id6746954963?pt=123127751&ct=macrowave.co&mt=8"
             target="_blank"
             rel="noopener noreferrer"
             className="inline-block">
            <img src="/images/app-store-badge.svg"
                 alt="Download on the App Store"
                 width="120"
                 height="40"
                 className="h-10" />
          </a>
        </div>
      </div>
    </div>
  );
}
